import script from "./Remains.vue?vue&type=script&setup=true&lang=js"
export * from "./Remains.vue?vue&type=script&setup=true&lang=js"

import "./Remains.vue?vue&type=style&index=0&id=43c2d0db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c2d0db"]])

export default __exports__